import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { KeystoreAccessService } from '../services/keystore-access.service';

@Injectable({ providedIn: 'root' })
export class KeystoreAdminGuard implements CanActivate {
  constructor(
    private readonly accessService: KeystoreAccessService,
    private readonly router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const organisationId = this.findOrganisationId(route);
    if (organisationId !== null && this.accessService.hasAdminRole(organisationId)) {
      return true;
    }
    return this.router.createUrlTree(
      organisationId === null
        ? ['/marktplatz']
        : ['/organisations', organisationId, 'information']
    );
  }

  private findOrganisationId(route: ActivatedRouteSnapshot): number | null {
    for (const snapshot of [...route.pathFromRoot].reverse()) {
      const raw = snapshot.paramMap.get('organisationId');
      if (raw !== null && Number.isInteger(Number(raw)) && Number(raw) > 0) {
        return Number(raw);
      }
    }
    return null;
  }
}
